/* eslint-disable */
import React from 'react'
import Container from '../../../../../components/layouts/container'
import {
  TitleOne,
  BorderText,
  TitleParagraph
} from '../../../../../components/text'
import BreadCrumb from '../../../../../components/breadcrumb'
import { Grid, Row, Col } from 'react-flexbox-grid'
import HeroBannerImage from '../../../../../static/images/landing-page-one/background/hero-banner.svg'
import HeroBannerPeople from '../../../../../static/images/hero-banner/about.webp'
import HeroBannerStyle from './index.style'
import { useTranslation } from "react-i18next";

const HeroBanner = () => {
  const { t } = useTranslation();
  return (
    <HeroBannerStyle>
      <img className="hero-banner--background" src={HeroBannerImage} alt="" loading="lazy" />
      <div className="hero-banner--people">
        <img className="" src={HeroBannerPeople} alt="" loading="lazy" />
      </div>
      {/* <Container> */}
      <div className="hero-banner">
        <Grid>
          <Row>
            <Col xs={6} md={6} lg={6} className="section-1-tentang-kami">
              <BreadCrumb
                options={[
                  {
                    name: 'Beranda',
                    link: '/'
                  },
                  {
                    name: 'Tentang Kami',
                    link: false
                  }
                ]}
              ></BreadCrumb>
              <TitleOne display="block" align="left">
                {t('pageAbout.part1')}
              </TitleOne>
              <BorderText></BorderText>
              <div style={{ marginTop: 30 }}>
                <TitleParagraph display="block" align="left">
                  {t('pageAbout.part2')}
                </TitleParagraph>
              </div>
              <div>
                <p className="hero-desc">
                  {t('pageAbout.part3')}
                </p>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
      {/* </Container> */}
    </HeroBannerStyle>
  )
}

export default HeroBanner
